const isProd = process.env.NODE_ENV === "production";

const API_BASE_URL = isProd
  ? window.APP_CONFIG?.API_BASE_URL
  : process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
  console.error("API_BASE_URL is not defined");
}

export default API_BASE_URL;
